(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["offer-carousel"] && !Shopify.designMode) return;
  try {
    (function(){document.querySelectorAll('[data-wc-offer-viewport]').forEach(function(viewport){viewport.addEventListener('wheel',function(event){if(Math.abs(event.deltaY)>Math.abs(event.deltaX)){viewport.scrollLeft+=event.deltaY;event.preventDefault()}},{passive:false})})})();
  } catch(e) { console.error(e); }
})();

})();
